export function htmlGetter($el) {
  return ($el.html() || '').replace(/ dn-([a-zA-Z]+)=/g, ' $1=');
}

let incrementForLinkId = 0;

export function linkParser($link, groupId) {
  const data = $link.data();
  return {
    _uid: ++incrementForLinkId,
    url_id: $link.attr('url_id'),
    href: $link.attr('href'),
    target: $link.attr('target'),
    auth: $link.attr('auth') !== undefined,
    className: $link.attr('class'),
    label: htmlGetter($link),
    data,
    tags: data.tag ? data.tag.split(',') : [],
    groupId,
  }
}

export function getRoundedHref(href) {
  return href.split('#')[0].split('?')[0].replace(/\/index\.html$/, '');
}

export function parseDateString(str) {
  const dt = new Date(str.replace(/-/g, '/'));
  const year = dt.getFullYear();
  const month = dt.getMonth();
  const day = dt.getDate();
  const hours = dt.getHours();
  const minutes = dt.getMinutes();

  const shortLabel = (month + 1) + '/' + day;

  return {
    year,
    month,
    day,
    hours,
    minutes,
    shortLabel,
    fullLabel: year + '/' + shortLabel,
    timestamp: dt.getTime(),
  }
}



// WEBPACK FOOTER //
// ./src/js/store/modules/util/index.js